import { SET_SOURCES_CATALOG_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

const initialState = {
  category: 'View All',
  searchTerm: ''
}

export default createSettingsReducer(SET_SOURCES_CATALOG_SETTINGS, initialState)



// WEBPACK FOOTER //
// ./reducers/application/sources-catalog.js